import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsSchemaEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-assets-schema-entrypoint" */ './index.tsx'),
	),
	getPreloadProps: () => ({}),
});
